import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
// arco
import { Layout } from "@arco-design/web-react";
import NavVertical from "src/layouts/dashboard/nav-vertical";
import Header from "src/layouts/dashboard/header";
import { useBoolean } from "src/hooks/use-boolean";
import { useResponsive } from "src/hooks/use-responsive";
import { NAV } from "../config-layout";


// ----------------------------------------------------------------------

export default function DashboardLayout({ children }) {
    const nav = useBoolean();
    const lgUp = useResponsive("up", "lg");
    
    // const timeOutId = useRef();

    // ----------------------------------


    // useEffect(() => {
    //     const handleResize = () => {
    //         // noop for now — kept debounce for potential future use
    //     };

    //     const onResize = () => {
    //         clearTimeout(timeOutId.current);
    //         timeOutId.current = setTimeout(handleResize, 500);
    //     };

    //     window.addEventListener("resize", onResize);
    //     return () => {
    //         window.removeEventListener("resize", onResize);
    //         clearTimeout(timeOutId.current);
    //     };
    // }, []);

    // ----------------------------------

    return (
        <div style={{ minHeight: '100vh', position: 'relative' }}>
            <Header onOpenNav={ nav.onTrue }/>

            <div style={{ display: 'flex', alignItems: 'stretch', flexDirection: 'row', height: '100vh', maxHeight: '100vh', paddingTop: 60,  }}>
                <NavVertical openNav={ nav.value } onCloseNav={ nav.onFalse }/>
                <div style={{
                    height: '100%',
                    backgroundColor: '#F7F8FA',
                    padding: 20,
                    width: lgUp ? `calc(100% - ${ NAV.W_VERTICAL }px)` : '100%',
                }}>
                    {children}
                </div>
            </div>
        </div>
    );
}

DashboardLayout.propTypes = {
    children: PropTypes.node
};
